<div class="mat-body-2">
	<h1>YSTM Race-Track</h1>
	<p>Der YSTM richtet alljährlich eine Zahl von
		Regatten aus. Hier ein Rückblick über die vergangenen Jahre.</p>

	<mat-toolbar color="primary">2026</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2026</p>
			<ul>
				<li>YSTM ILCA KickOff 2026</li>
				<li>YSTM Opti KickOff 2026</li>
				<li>Herbstwettfahrten: Javelin, Flying Dutchman, P-Boot (15qm JK)</li>
				<li>Dart-18 IDB</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2025</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2025</p>
			<ul>
				<li>YSTM Opti KickOff / ILCA KickOff 2025</li>
				<li>Herbstwettfahrten: Flying Dutchman, P-Boot (15qm JK), Conger, Contender</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2024</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2024</p>
			<ul>
				<li>Cat-Auftakt Dart 18, Topcat, A-Cat, Hobie (14,16)</li>
				<li>Opti KickOff / ILCA KickOff 2024</li>
				<li>Herbstwettfahrten: P-Boot (15qm JK), Javelin, Flying Dutchman, Conger, Contender</li>
				<li>IDB 2024 der Topcat-Klasse</li>
				<li>Cat-Ausklang, Dart18, A-Cat, Hobie (14,16)</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2023</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2023</p>
			<ul>
				<li>Opti KickOff / ILCA KickOff 2023</li>
				<li>Cat-Auftakt Dart 18, Topcat, A-Kat, F18</li>
				<li>Herbstwettfahrten: P-Boot, FD, Javelin</li>
				<li>Cat-Ausklang, Dart18, Topcat, A-Cat</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2022</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2022</p>
			<ul>
				<li>Cat-Auftakt Topcat (K1,K2,K3,K4solo), A-Kat, Dart 18</li>
				<li>Opti KickOff / ILCA KickOff 2022</li>
				<li>Herbstwettfahrten: Javelin, Flying Dutchman und 15er JK (P-Boot)</li>
				<li>Teenymania Steinhuder Meer: Teeny</li>
				<li>Cat-Ausklang Dart 18, Topcat K1, K2, K3</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2021</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2021</p>
			<ul>
				<li>KV Teeny Training im YSTM</li>
				<li>Herbstwettfahrten: Javelin, Flying Dutchman und 15er JK (P-Boot)</li>
				<li>Vorregatta zur IDM 15er JK (P-Boot)</li>
				<li>IDM 15er JK (P-Boot)</li>
				<li>Cat-Ausklang Dart 18, A-Cat, Topcat K1, K2, K3, K4</li>
			</ul>
		</mat-card-content>
	</mat-card>
	<mat-toolbar color="primary">2020</mat-toolbar>
	<mat-card>
		<mat-card-content>
			<p>Im Jahr 2020</p>
			<ul>
				<li>Herbstwettfahrten: Javelin, Flying Dutchman und 15er JK (P-Boot)</li>
				<li>Cat-Ausklang Dart 18, A-Cat, Topcat K1, K2, K3, K4</li>
				<li>Opti KickOff (Out) 2020</li>
			</ul>
		</mat-card-content>
	</mat-card>


	<!-- <p>
          2016 stand die Landes Jugend- und Jüngsten-Meisterschaft Niedersachsen im Fokus: 9 Bootsklassen, 180 Boote,
          230 jugendliche Segler auf dem Steinhuder Meer.
        </p> -->

</div>